import { JetView } from 'webix-jet';
import { devConfig } from 'config/config';

/**
 * Class representing the customer information view.
 * @extends JetView
 */
export default class myInfoCustomerView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Current screen size
        const theme = this.app.config.theme; // Current theme

        // Main information form configuration
        const main_info = {
            margin: 10,
            rows: [
                {
                    view: 'text',
                    name: 'Id',
                    label: _("<span class='icon-id'></span> ID"),
                    labelPosition: 'top',
                    placeholder: _('Id'),
                    invalidMessage: _('A ID is required'),
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'FirstName',
                    label: _('Primer Nombre'),
                    labelPosition: 'top',
                    placeholder: _('Primer Nombre'),
                    invalidMessage: _('A name is required'),
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'MiddleName',
                    label: _('Segundo Nombre'),
                    labelPosition: 'top',
                    placeholder: _('Segundo Nombre'),
                    invalidMessage: _('A name is required'),
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'LastName',
                    label: _('Apellido'),
                    labelPosition: 'top',
                    placeholder: _('Apellido'),
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'DocNumber',
                    label: _('Numero de Documento'),
                    labelPosition: 'top',
                    placeholder: _('Numero de Documento'),
                    disabled: true, // Field is disabled
                },
                {
                    view: 'richselect',
                    name: 'Gender',
                    localId: 'Gender:combo',
                    label: _('Género'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: ['M', 'F'], // Gender options
                    disabled: true, // Field is disabled
                },
                {
                    view: 'datepicker',
                    name: 'BirthDate',
                    label: _('Cumpleaños'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    format: webix.Date.dateToStr('%d %M %Y'), // Date format
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'Currency',
                    label: _("<span class='webix_icon mdi mdi-coin'></span> Moneda"),
                    labelPosition: 'top',
                    placeholder: _('Moneda'),
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'Balance',
                    label: _('Balance'),
                    labelPosition: 'top',
                    placeholder: _('Balance'),
                    disabled: true, // Field is disabled
                },
                {
                    view: 'richselect',
                    name: 'Estado',
                    label: _('Estado'),
                    labelPosition: 'top',
                    localId: 'Estado:combo',
                    placeholder: _('Click para seleccionar '),
                    options: [
                        { id: 'A', value: _('Active') },
                        { id: 'I', value: _('Inactive') },
                    ],
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'IsLocked',
                    label: _('Está bloqueado?'),
                    labelPosition: 'top',
                    placeholder: _('Está bloqueado?'),
                    disabled: true, // Field is disabled
                },
            ],
        };

        // Notifications configuration
        const notifications = {
            view: 'radio',
            name: 'notifications',
            label: _('Notificaciones'),
            labelPosition: 'top',
            value: 1, // Default value
            options: [
                { id: 1, value: _('Si') },
                { id: 2, value: _('No') },
            ],
        };

        // Left main section configuration
        const left_main = {
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [main_info],
        };

        // More information section configuration
        const more_info = {
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [
                {
                    view: 'richselect',
                    name: 'CountryId',
                    id: 'country',
                    localId: 'country:combo',
                    label: _('País Residencia'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [], // Options will be populated dynamically
                    disabled: true, // Field is disabled
                },
                {
                    view: 'richselect',
                    name: 'RegionId',
                    id: 'ProvinceRegion',
                    localId: 'ProvinceRegion:combo',
                    label: _('Provincia/Región Residencia'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [], // Options will be populated dynamically
                    disabled: true, // Field is disabled
                },
                {
                    view: 'richselect',
                    name: 'CityId',
                    id: 'City',
                    localId: 'cities:combo',
                    label: _('Ciudad Residencia'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [], // Options will be populated dynamically
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'Address',
                    label: _('Dirección'),
                    labelPosition: 'top',
                    placeholder: _('Dirección'),
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'ZipCode',
                    label: _('Código Zip'),
                    labelPosition: 'top',
                    placeholder: _('Código Zip'),
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'Phone',
                    label: _("<span class='icon-phone1'></span> Teléfono"),
                    labelPosition: 'top',
                    placeholder: _('Teléfono'),
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'MobilePhone',
                    label: _('Celular'),
                    labelPosition: 'top',
                    placeholder: _('Celular'),
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'Email',
                    label: _('Email'),
                    labelPosition: 'top',
                    placeholder: 'Email',
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'CreatedLocalDate',
                    label: _('Fecha de registro'),
                    labelPosition: 'top',
                    placeholder: 'Fecha de registro',
                    disabled: true, // Field is disabled
                },
            ],
        };

        // Right photo section configuration
        const right_photo = {
            gravity: 3,
            margin: 10,
            rows: [
                {
                    view: 'photo',
                    name: 'photo',
                    css: 'form_photo',
                    width: 260,
                    height: 260,
                    borderless: true, // No border
                },
                {
                    view: 'multicombo',
                    name: 'tags',
                    localId: 'tags:combo',
                    placeholder: _('Click to add tags'),
                    options: [], // Options will be populated dynamically
                },
            ],
        };

        // Upper section configuration for larger screens
        const upper_section = {
            multiview: true,
            padding: 10,
            cols: [left_main, { gravity: 0, minWidth: 20 }, more_info],
        };

        // Upper section configuration for smaller screens
        const upper_section_narrow = {
            cols: [
                {
                    gravity: 4,
                    margin: 10,
                    rows: [main_info, more_info],
                },
            ],
        };

        // Buttons configuration
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Guardar'), // Save button label
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        if (this.getRoot().validate()) {
                            // Validate form
                            const newdata = this.getRoot().getValues(); // Get form values
                            this.app.callEvent('customer:save', [newdata]); // Trigger save event
                        }
                    },
                },
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode

        // Return the main form configuration
        return {
            view: 'form',
            rows: [
                {
                    view: 'toolbar',
                    css: theme, // Apply theme to toolbar
                    elements: [
                        {
                            view: 'label',
                            label: _('Mi Información'), // Toolbar label
                            width: 150,
                        },
                    ],
                },
                screen !== 'small' ? upper_section : upper_section_narrow, // Conditional layout based on screen size
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} form - The form instance.
     */
    init(form) {
        var vthis = this; // Preserve context for event handlers

        // Event listener for updating the form with customer data
        this.on(this.app, 'form:update2', (id) => {
            webix.ajax().get(devConfig.geturlApi() + 'Client/GetClientById', 'id=' + id, {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error message on failure
                },
                success: function (text, data, XmlHttpRequest) {
                    text = JSON.parse(text); // Parse response
                    vthis.app.callEvent('customer:updatedata', [
                        text[0], // Trigger update event with customer data
                    ]);
                    $$('country').setValue(text[0].CountryId); // Set country value
                    webix.delay(
                        function () {
                            $$('ProvinceRegion').setValue(
                                text[0].RegionId, // Set region value
                            );
                            webix.delay(
                                function () {
                                    $$('City').setValue(text[0].CityId); // Set city value
                                },
                                '',
                                '',
                                1000, // Delay for setting city value
                            );
                        },
                        '',
                        '',
                        1000, // Delay for setting region value
                    );
                },
            });
        });

        // Fetching countries for the country dropdown
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type for request
            })
            .post(devConfig.geturlApi() + 'Agent/GetAgentCountries', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error message on failure
                },
                success: function (text, data, XmlHttpRequest) {
                    var data = JSON.parse(text.replace(/"Id"/g, '"id"').replace(/"Name"/g, '"value"')); // Parse and format response
                    var optionsCountries = $$('country').getList();
                    optionsCountries.clearAll(); // Clear existing options
                    optionsCountries.parse(data.Data); // Populate country options
                    vthis.app.callEvent('form:update2', [
                        vthis.getParam('user', true), // Trigger update event with user parameter
                    ]);
                },
            });

        // Event listener for updating form values with customer data
        this.on(
            this.app,
            'customer:updatedata',
            (person) => form.setValues(person), // Set form values with customer data
        );

        // Event listener for selecting a person
        this.on(this.app, 'person:select', (person) => form.setValues(person));

        // Event listener for country change
        $$('country').attachEvent('onChange', function (newv, oldv) {
            var optionscountries = this.getList().getItem(newv); // Get selected country
            var optionsProvinceRegions = $$('ProvinceRegion').getList();
            optionsProvinceRegions.clearAll(); // Clear existing province/region options
            optionsProvinceRegions.parse(optionscountries.departments); // Populate province/region options
        });

        // Event listener for province/region change
        $$('ProvinceRegion').attachEvent('onChange', function (newv, oldv) {
            var optionsProvinceRegions = this.getList().getItem(newv); // Get selected province/region
            var optionsCity = $$('City').getList();
            optionsCity.clearAll(); // Clear existing city options
            if (optionsProvinceRegions != undefined) {
                optionsCity.parse(optionsProvinceRegions.cities); // Populate city options
            }
        });
    }

    /**
     * Retrieves localized options for combo boxes.
     */
    getLocalizedComboOptions() {
        const _ = this.app.getService('locale')._; // Localization service
        let p_options = webix.copy(getPositions()); // Get position options
        p_options.map((x) => (x.value = _(x.value))); // Localize position values
        this.$$('position:combo').getPopup().getList().parse(p_options); // Populate position combo

        let t_options = webix.copy(getTags()); // Get tag options
        t_options.map((x) => (x.value = _(x.value))); // Localize tag values
        this.$$('tags:combo').getPopup().getList().parse(t_options); // Populate tags combo

        let c_options = webix.copy(getCities()); // Get city options
        c_options.map((x) => (x.value = _(x.value))); // Localize city values
        this.$$('cities:combo').getPopup().getList().parse(c_options); // Populate cities combo
    }
}

// FILE DOCUMENTED
